/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import { api } from 'services/api';
import { PayloadAction } from '@reduxjs/toolkit';
import { PAGE_SIZE } from 'services/constants/env';
import { notificationContainer } from 'utils/notificationContainer';
import {
	addMonthlyFeeRequest,
	deleteMonthlyFeeRequest,
	getEMerchantRequest,
	getEMerchantSuccess,
	getFeeClassesRequest,
	getFeeClassesSuccess,
	getMonthlyFeeListRequest,
	getMonthlyFeeListSuccess,
	getMonthlyFeeRequest,
	getMonthlyFeeSuccess,
} from './reducer';
import {
	TAddMonthlyFeeRequestPayload,
	TDeleteMonthlyFeeRequestPayload,
	TEMerchantsResponsePayload,
	TFeeClassResponsePayload,
	TMonthlyFeeListRequestPayload,
	TMonthlyFeeListResponsePayload,
	TMonthlyFeeResponsePayload,
} from './types';

function* getEMerchantRequestWorker() {
	try {
		const response: TEMerchantsResponsePayload = yield call(api.monthlyFee.getEMerchant);
		yield put(getEMerchantSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	}
}

function* getMonthlyFeeRequestWorker() {
	try {
		const response: TMonthlyFeeResponsePayload = yield call(api.monthlyFee.getMonthlyFee);
		yield put(getMonthlyFeeSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	}
}

function* getFeeClassesRequestWorker() {
	try {
		const response: TFeeClassResponsePayload = yield call(api.monthlyFee.getFeeClasses);
		yield put(getFeeClassesSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	}
}

function* getMonthlyFeeListRequestWorker(action: PayloadAction<TMonthlyFeeListRequestPayload>) {
	try {
		const response: TMonthlyFeeListResponsePayload = yield call(
			api.monthlyFee.getMonthlyFeeList,
			action.payload,
		);
		yield put(getMonthlyFeeListSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	}
}

function* addMonthlyFeeRequestWorker(action: PayloadAction<TAddMonthlyFeeRequestPayload>) {
	try {
		yield call(api.monthlyFee.addMonthlyFee, action.payload);
		yield put(getMonthlyFeeListRequest({ pageSize: PAGE_SIZE, pageNumber: 1 }));
		yield notificationContainer('Position was successfully added', 'success');
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data), 'error');
		}
		// yield put(assetsInitState());
	}
}

function* deleteMonthlyFeeRequestWorker(action: PayloadAction<TDeleteMonthlyFeeRequestPayload>) {
	const { payload } = action;
	try {
		yield call(api.monthlyFee.deleteMonthlyFee, payload);
		yield put(getMonthlyFeeListRequest({ pageSize: PAGE_SIZE, pageNumber: 1 }));
		yield notificationContainer('Position was successfully deleted', 'success');
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	}
}

export function* monthlyFeeSaga() {
	yield takeEvery(getEMerchantRequest.type, getEMerchantRequestWorker);
	yield takeEvery(getMonthlyFeeRequest.type, getMonthlyFeeRequestWorker);
	yield takeEvery(getFeeClassesRequest.type, getFeeClassesRequestWorker);
	yield takeEvery(getMonthlyFeeListRequest.type, getMonthlyFeeListRequestWorker);
	yield takeEvery(addMonthlyFeeRequest.type, addMonthlyFeeRequestWorker);
	yield takeEvery(deleteMonthlyFeeRequest.type, deleteMonthlyFeeRequestWorker);
}
